import React from 'react';
import { ToggleButtonItem, ToggleButton, Panel, PanelTheme } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

export const ToggleButtonDemo: React.FC<{}> = ({}) => {
    const yesNoButtonItems: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
        },
    ];

    const yesNoDefaultSelectedButtonItems = ['Yes'];

    const dollarPercentButtonItems: ToggleButtonItem[] = [
        {
            id: 'dollar',
            text: '$',
            hint: 'Click $',
        },
        {
            id: 'percent',
            text: '%',
            hint: 'Click %',
        },
    ];

    const dollarPercentDefaultSelectedButtonItems = ['percent'];

    const itemClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        alert(`The "${e.itemData.text}" button was clicked`);
    };

    const onSelectedItemsChange = (e: any) => {
        // if (e[0]) {
        //     alert('The following item is selected: ' + e[0].text);
        // }
    };

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Toggle Button</li>
            <br />
            <Panel
                theme={PanelTheme.White}
                width='200px'
            >
                <ToggleButton
                    id='toggleButtonDemoYesNo'
                    items={yesNoButtonItems}
                    defaultSelectedItems={yesNoDefaultSelectedButtonItems}
                    stylingMode='outlined'
                    onItemClick={itemClick}
                    onSelectedItemsChange={onSelectedItemsChange}
                    width='180px'
                />
                <br />
                <ToggleButton
                    id='toggleButtonDemoPercentDollar'
                    items={dollarPercentButtonItems}
                    defaultSelectedItems={dollarPercentDefaultSelectedButtonItems}
                    stylingMode='outlined'
                    onItemClick={itemClick}
                    onSelectedItemsChange={onSelectedItemsChange}
                    width='80px'
                />
            </Panel>
        </div>
    );
};
